module.exports = __webpack_public_path__ + "img/example9-1.9bb3d8a9.png";